import PropTypes from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        Bulunamadı
      </Typography>
      <Typography variant="body2" align="center">
        Arama kriteri &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. Lütfen başka bir kriter ile tekrar deneyiniz.
      </Typography>
    </Paper>
  );
}
